/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useEmployeeContext } from "../../../context/employee-context";
import { useToast } from "../../../context/toast-context";
import useAPIHandler from "../../../hook/use-api-handler";
import { getInputFieldProps, pickProperties, safeToString } from "../../../utils/common";
import fetchDataWithPromise, { fetchDataWithPromiseAndStoreData } from "../../../utils/fetch-data";
import { EXIT_FORMALITY_API, EXIT_FORMALITY_FIELDS, EXIT_FORMALITY_INITIAL_STATE } from "./exit-formality-constant";
import { createExitFormalitySchema } from "./exit-formality-validation";

const useExitFormalityService = () => {
    const [errors, setErrors] = useState({});
    const [createFormUpdateLoading, setCreateFormUpdateLoading] = useState(false);
    const [exitFormalityInput, setExitFormalityInput] = useState(EXIT_FORMALITY_INITIAL_STATE);
    const [exitFormalityModal, setExitFormalityModal] = useState(false)
    const exitFormalityModalOpen = () => {
        setExitFormalityModal(true)
    }
    const exitFormalityModalClose = () => {
        setExitFormalityModal(false)
    }
    const { fetchData } = useAPIHandler();
    const { showToastMessage } = useToast();
    const { id: employeeID } = useParams();
    const handleClickOpen = () => {
        setErrors({});
        exitFormalityModalOpen();
    };
    const {
        employeeInfo: imployeeInfoFromDB,
        employeeProfileUILoading
    } = useEmployeeContext() || {};
    const handleBlurFn = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
        }
        const fieldSchema = createExitFormalitySchema.extract(name);
        const { error } = fieldSchema.validate(value, {
        });
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: error ? error.details[0].message : undefined,
        }));
    }
    const handleChangeFunction = (e, name) => {
        let value = e;
        if (e && e.target) {
            value = e.target.value;
        }
        if (
            EXIT_FORMALITY_FIELDS[name]?.customOptions &&
            EXIT_FORMALITY_FIELDS[name]?.customOptions?.formatValueFn
        ) {
            value = EXIT_FORMALITY_FIELDS[name].customOptions.formatValueFn(
                value,
                exitFormalityInput
            );
        }

        setExitFormalityInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }));

        if (createExitFormalitySchema) {
            const fieldSchema = createExitFormalitySchema.extract(name);

            if (fieldSchema) {

                const { error } = fieldSchema.validate(value);

                if (!error) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: undefined,
                    }));
                }
            }
        }
    };
    const getInputFieldPropsFn = (fieldName = "") => {
        const { customOptions = {}, ...restProps } =
            EXIT_FORMALITY_FIELDS[fieldName] || {};
        const error = safeToString(errors[fieldName]);
        const props = {
            ...restProps,
            ...getInputFieldProps({
                name: fieldName,
                stateValues: exitFormalityInput,
                type: restProps.type || "text",
                error,
                handleBlurFn,
                handleChangeFunction,
            }),
        };

        return props;
    };

    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const [resource, setResource] = useState(null);

    useEffect(() => {
        // Refetch data whenever `page` or `search` changes
        const promiseData = fetchDataWithPromiseAndStoreData(
            `${EXIT_FORMALITY_API.EXIT_FORMALITY_GET.url}/${employeeID}`
          );
          setResource(promiseData.wrapPromise);
          promiseData.promise.then(res => {
            setExitFormalityInput({...res?.data?.data});
       
          })

    }, [page, search]);
    const handleSubmit = async () => {
        setCreateFormUpdateLoading(true);
        const { error, value } = createExitFormalitySchema.validate(pickProperties(exitFormalityInput, Object.keys(structuredClone(EXIT_FORMALITY_INITIAL_STATE))),
            {
                abortEarly: false,
                context: {
                    ...exitFormalityInput,
                },
            }
        );
        const {
            exit_date,
            settlement_date,
            reason_for_exit
        } = exitFormalityInput;
        let validationErrors = {};
        if (error && error?.details?.length > 0) {
            validationErrors = error.details.reduce((acc, err) => {
                const pathname = err.path.join(".");
                acc[pathname] = err.message;
                return acc;
            }, {});
        }
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setCreateFormUpdateLoading(false);
        } else {
            setErrors({});
            const rawData = { ...value };
            const isEdit = !!exitFormalityInput?.exit_formality_id;
            try {
                const apiConfig = isEdit
                    ? {
                        data: rawData,
                        ...EXIT_FORMALITY_API.EXIT_FORMALITY_UPDATE,
                        url: `${EXIT_FORMALITY_API.EXIT_FORMALITY_UPDATE.url}/${employeeID}/update/${exitFormalityInput?.exit_formality_id}`,
                    }
                    : {
                        data: rawData,
                        ...EXIT_FORMALITY_API.EXIT_FORMALITY_CREATE,
                        url: `${EXIT_FORMALITY_API.EXIT_FORMALITY_CREATE.url}/${employeeID}`,
                    };
                const res = await fetchData(apiConfig);


                showToastMessage({ message: `Exit Formality ${isEdit?"Update ":"Added "} Successfully!` });
                setCreateFormUpdateLoading(false);
                setResource(fetchDataWithPromise(`${EXIT_FORMALITY_API.EXIT_FORMALITY_GET.url}/${employeeID}`));
                exitFormalityModalClose()

            } catch (error) {
                if (error?.type === "JoiValidationError") {
                    const errorsAll = {};

                    error?.errors?.map((item) => {
                        const { field, message } = item;
                        errorsAll[field] = message;
                    });

                    showToastMessage({
                        message:
                            Object.keys(errorsAll).length > 0
                                ? "Validation Error!"
                                : "Something went wrong!",
                        color: "danger",
                    });
                    setErrors(errorsAll);
                }

                if (error?.type === "GeneralError") {
                    showToastMessage({
                        message: error.message || "An unknown general error occurred.",
                        color: "danger",
                    });
                }
                setCreateFormUpdateLoading(false);
            }
        }
    }
    return {
        getInputFieldPropsFn,
        handleSubmit,
        createFormUpdateLoading,
        exitFormalityInput,
        setExitFormalityInput,
        resource,
        exitFormalityModal,
        exitFormalityModalOpen,
        exitFormalityModalClose,
        handleClickOpen,
        imployeeInfoFromDB
    }
}

export default useExitFormalityService

